import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { NumericFormat } from "react-number-format";

function AddConvenioDade() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [form, setForm] = useState({
    objeto: "",
    objeto_completo: "",
    cp_dl_tp: "",
    contrato: "",
    numero_convenio: "",
    ano: "",
    repasse: "",
    contrapartida: "",
    assinatura_termo: "",
    vigencia_convenio: "",
    vigencia_contrato: "",
    empresa: "",
    ois: "",
    fiscal_contador: "",
    conta_bancaria: "",
    recurso_liberado: "",
    status: "",
  });

  useEffect(() => {
    if (id) {
      axios
        .get(`/api/conveniosdade/${id}`)
        .then((res) => {
          setForm(res.data);
        })
        .catch((err) => {
          console.error("Erro ao buscar dados:", err);
          alert("Erro ao carregar os dados do convênio");
        });
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleValueChange = (name, value) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const request = id
      ? axios.put(`/api/conveniosdade/${id}`, form)
      : axios.post("/api/conveniosdade", form);

    request
      .then((res) => {
        const sucesso =
          res.data.Status === "Success" || res.data.message?.includes("sucesso");
        if (sucesso) {
          alert(id ? "Convênio atualizado com sucesso!" : "Convênio criado com sucesso!");
          navigate("/conveniosdade");
        } else {
          alert("Erro ao salvar o convênio");
        }
      })
      .catch((err) => {
        console.error(err);
        alert("Erro no servidor");
      });
  };

  return (
    <div className="px-4 py-3" style={{ width: "100%" }}>
      <h3 className="mb-4">{id ? "Editar" : "Adicionar"} Convênio DADE</h3>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Objeto</label>
          <input
            type="text"
            name="objeto"
            className="form-control"
            value={form.objeto}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label>Objeto Completo</label>
          <input
            type="text"
            name="objeto_completo"
            className="form-control"
            value={form.objeto_completo}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>CP/DL/TP</label>
          <input
            type="text"
            name="cp_dl_tp"
            className="form-control"
            value={form.cp_dl_tp}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Contrato</label>
          <input
            type="text"
            name="contrato"
            className="form-control"
            value={form.contrato}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Número do Convênio</label>
          <input
            type="text"
            name="numero_convenio"
            className="form-control"
            value={form.numero_convenio}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Ano</label>
          <input
            type="number"
            name="ano"
            className="form-control"
            value={form.ano}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Repasse (R$)</label>
          <NumericFormat
            name="repasse"
            className="form-control"
            value={form.repasse}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            fixedDecimalScale={true}
            allowNegative={false}
            onValueChange={(values) =>
              handleValueChange("repasse", values.floatValue || "")
            }
            placeholder="0,00"
          />
        </div>

        <div className="mb-3">
          <label>Contrapartida (R$)</label>
          <NumericFormat
            name="contrapartida"
            className="form-control"
            value={form.contrapartida}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            fixedDecimalScale={true}
            allowNegative={false}
            onValueChange={(values) =>
              handleValueChange("contrapartida", values.floatValue || "")
            }
            placeholder="0,00"
          />
        </div>

        <div className="mb-3">
          <label>Recurso Liberado</label>
          <input
            type="text"
            name="recurso_liberado"
            className="form-control"
            value={form.recurso_liberado}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Assinatura Termo</label>
          <input
            type="text"
            name="assinatura_termo"
            className="form-control"
            value={form.assinatura_termo}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Vigência Convênio</label>
          <input
            type="text"
            name="vigencia_convenio"
            className="form-control"
            value={form.vigencia_convenio}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Vigência Contrato</label>
          <input
            type="text"
            name="vigencia_contrato"
            className="form-control"
            value={form.vigencia_contrato}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Empresa</label>
          <input
            type="text"
            name="empresa"
            className="form-control"
            value={form.empresa}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>OIS</label>
          <input
            type="text"
            name="ois"
            className="form-control"
            value={form.ois}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Fiscal / Contador</label>
          <input
            type="text"
            name="fiscal_contador"
            className="form-control"
            value={form.fiscal_contador}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Conta Bancária</label>
          <input
            type="text"
            name="conta_bancaria"
            className="form-control"
            value={form.conta_bancaria}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Status</label>
          <input
            type="text"
            name="status"
            className="form-control"
            value={form.status}
            onChange={handleChange}
          />
        </div>

        <button type="submit" className="btn btn-primary">
          {id ? "Atualizar" : "Salvar"} Convênio DADE
        </button>
      </form>
    </div>
  );
}

export default AddConvenioDade;
